import type { PDFReader, PDFReaderOptions } from "@pdfking/renderer-api"

export const CreatePDFReader = (
  options: PDFReaderOptions
): Promise<PDFReader> =>
  import("../utils/Proxy").then(({ CreatePDFReader }) =>
    CreatePDFReader(options)
  )
